<template>
  <router-view></router-view>
</template>

<script>
export default {
  data: () => ({}),
  mounted() {
    window.addEventListener('beforeunload', event => {
      if (this.$store.getters.ActiveHttpRequests > 0) {
        event.preventDefault();
        event.returnValue = '';
      }
    });
  }
};
</script>

<style lang="scss">
html {
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
</style>
